import React, { useEffect, useRef, useState } from "react";

interface Slide {
  id: string;
  image: any;
  alt: string;
}
// --- Helpers -------------------------------------------------------------
function classNames(...cls: (string | false | null | undefined)[]) {
  return cls.filter(Boolean).join(" ");
}

// --- Hero Slider (custom) -----------------------------------------------
function SliderCharity({ slides }: { slides: Slide[] }) {
  const [index, setIndex] = useState(0);
  const [pause, setPause] = useState(false);
  const timeoutRef = useRef<number | null>(null);

  const next = () => setIndex((i) => (i + 1) % slides.length);
  const prev = () => setIndex((i) => (i - 1 + slides.length) % slides.length);

  useEffect(() => {
    if (pause) return;
    timeoutRef.current && window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(next, 5000);
    return () => {
      timeoutRef.current && window.clearTimeout(timeoutRef.current);
    };
  }, [index, pause, slides.length]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <section
      className="relative h-[340px] w-full overflow-hidden font-abel rounded-2xl"
      aria-roledescription="carousel"
      aria-label="Give Back hero"
      onMouseEnter={() => setPause(true)}
      onMouseLeave={() => setPause(false)}
    >
      {/* Slides */}
      <div
        className="absolute inset-0 flex h-full w-full transition-transform duration-700"
        style={{ transform: `translateX(-${index * 100}%)` }}
      >
        {slides.map((s) => (
          <div
            key={s.id}
            className="relative h-full w-full flex-none text-[white] text-center"
          >
            <img
              src={s.image}
              alt={s.alt}
              className="absolute inset-0 h-full w-full object-cover"
            />
            {/* <div className="absolute inset-0 bg-gradient-to-t from-[black]/60 via-[black]/30 to-transparent" /> */}
          </div>
        ))}
      </div>

      {/* Dots */}
      <div className="pointer-events-none absolute bottom-4 left-1/2 z-10 -translate-x-1/2">
        <div className="flex items-center gap-2">
          {slides.map((s, i) => (
            <button
              key={s.id}
              aria-label={`Go to slide ${i + 1}`}
              onClick={() => setIndex(i)}
              className={classNames(
                "pointer-events-auto h-2.5 w-2.5 rounded-full border border-white/70",
                i === index ? "bg-white" : "bg-white/20 hover:bg-white/40"
              )}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default SliderCharity;
